/*
 * @Description: 实时轨迹页 — 路由壳（团队工具 → 实时轨迹，路由 /member/track）
 *   同路由切换两个子视图：
 *   - 默认：驾驶舱视图 CockpitView（团队实时态）
 *   - 带 query ?replayUserId=&replayDate= ：个人轨迹回放视图 TrackReplay
 *   path 不变 → 左侧菜单「实时轨迹」保持高亮；query 在 URL → 刷新/深链接保留。
 *   CockpitView 始终挂载、进回放时仅用 display 隐藏（不卸载），返回时日期/筛选/
 *   时长/选中成员/地图视野等全部状态原样保留。
 */
import React, { useCallback, useState } from 'react'
import CockpitView from './CockpitView'
import TrackReplay from './replay'
import { CockpitMapStyle } from './constants'
import { loadMapStyle, saveMapStyle } from './utils/mapStyle'

interface MemberTrackProps {
  // 由 App.js 的 Route 透传（AdminRoleRender 转发 routeProps）
  location?: { search?: string }
}

const MemberTrack: React.FC<MemberTrackProps> = ({ location }) => {
  const search = (location && location.search) || window.location.search
  const params = new URLSearchParams(search)
  const replayUserId = params.get('replayUserId')
  const replayDate = params.get('replayDate') || ''
  const isReplay = !!replayUserId

  // 地图样式提升到此处：驾驶舱与回放页共用同一状态（同步），并持久化（下次进入沿用）
  const [mapStyle, setMapStyle] = useState<CockpitMapStyle>(loadMapStyle)
  const handleChangeMapStyle = useCallback((style: CockpitMapStyle) => {
    setMapStyle(style)
    saveMapStyle(style)
  }, [])

  // CockpitView 不卸载，进回放时由其自身 display:none 隐藏（不包额外 DOM 层，避免破坏
  // 父级 flex 布局导致容器宽度坍缩），全部状态原样保留；回放页覆盖在上层
  return (
    <>
      <CockpitView
        visible={!isReplay}
        mapStyle={mapStyle}
        onChangeMapStyle={handleChangeMapStyle}
      />
      {isReplay && (
        <TrackReplay
          userId={replayUserId}
          date={replayDate}
          mapStyle={mapStyle}
          onChangeMapStyle={handleChangeMapStyle}
        />
      )}
    </>
  )
}

export default MemberTrack
